import axios from 'axios';
import Dropzone from 'dropzone';
import { getAccessToken, isValidBearerToken } from '../auth/keycloakAuth.js';
import { resolveMigratedApiUrl } from '../api/MigratedApiRouting.js';

Dropzone.autoDiscover = false;

export default {
    getDropzone(dropzoneConfig) {
        const resolvedUrl = resolveMigratedApiUrl(dropzoneConfig.url);
        let cachedToken = null;
        const clearSlowUploadWarning = () => {
            const warningElement = document.querySelector('.slow-upload-warning');
            if (warningElement) warningElement.innerHTML = "";
        };
        const setSlowUploadWarning = (message) => {
            const warningElement = document.querySelector('.slow-upload-warning');
            if (warningElement) warningElement.innerHTML = message;
        };

        return new Dropzone(dropzoneConfig.documentElementId, {
            url: resolvedUrl,
            path: dropzoneConfig.path,
            paramName: dropzoneConfig.paramName ? dropzoneConfig.paramName : "imageFile",
            autoProcessQueue: typeof dropzoneConfig.autoProcessQueue !== 'undefined' ? dropzoneConfig.autoProcessQueue : true,
            uploadMultiple: dropzoneConfig.uploadMultiple ? dropzoneConfig.uploadMultiple : false,
            parallelUploads: dropzoneConfig.parallelUploads ? dropzoneConfig.parallelUploads : 2,
            maxFiles: dropzoneConfig.maxFiles ? dropzoneConfig.maxFiles : 1,
            maxFilesize: dropzoneConfig.maxFilesize ? dropzoneConfig.maxFilesize : 10,
            queueLimit: dropzoneConfig.queueLimit ? dropzoneConfig.queueLimit : 1,
            acceptedFiles: dropzoneConfig.acceptedFiles ? dropzoneConfig.acceptedFiles : ".jpg, .jpeg, .png, .svg, .gif",
            dictDefaultMessage: dropzoneConfig.dictDefaultMessage ? dropzoneConfig.dictDefaultMessage : '<p class="dz-default-message">Drop Your image here or <span class="blue">click to upload</span>.</p>',
            dictFileTooBig: dropzoneConfig.dictFileTooBig ? dropzoneConfig.dictFileTooBig : "This file is too large ({{filesize}} MB). The size limit is {{maxFilesize}} MB.",
            dictInvalidFileType: "Upload canceled: This file format is not supported. <br /> Use " + (dropzoneConfig.acceptedErrorMessage ? dropzoneConfig.acceptedErrorMessage : "png, jpeg, svg or gif") + ".",
            dictMaxFilesExceeded: "You can not upload more than {{maxFiles}} files.",
            previewTemplate: dropzoneConfig.previewTemplate ? dropzoneConfig.previewTemplate : '<div class="dz-preview dz-image-preview"><div class="dz-image"><img data-dz-thumbnail /></div><div class="dz-details"><div class="dz-size"><span data-dz-size=""></span></div><div class="dz-filename"><span data-dz-name=""></span></div></div><div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress=""></span></div><div class="dz-error-message"><span data-dz-errormessage=""></span></div><div class="dz-success-mark"></div><div class="dz-error-mark"></div></div>',
            thumbnailWidth: dropzoneConfig.thumbnailWidth ? dropzoneConfig.thumbnailWidth : null,
            thumbnailHeight: dropzoneConfig.thumbnailHeight ? dropzoneConfig.thumbnailHeight : 250,
            headers: {
                'X-CSRF-TOKEN': axios.defaults.headers.common['X-CSRF-TOKEN']
            },
            init() {
                this.on("thumbnail", function (file) {
                    if(file.size < 5030000 && (file.width > 3000 || file.height > 3000)) {
                        setSlowUploadWarning(`${!dropzoneConfig.uploadMultiple ? 'This image seems' : 'The images seem'} a bit big. Uploading can take several seconds.`)
                    }
                });
                this.on("maxfilesexceeded", function (file) {
                    clearSlowUploadWarning()
                    this.removeFile(file);
                });
                this.on("error", function (file, errormessage, xhr) {
                    clearSlowUploadWarning()
                    this.removeFile(file);
                    if (!file.accepted || xhr) this.removeFile(file);
                    if(dropzoneConfig.onErrorCallback) { dropzoneConfig.onErrorCallback(xhr, errormessage); }
                });
                this.on("addedfiles", function(files) {
                    if(dropzoneConfig.onAddedFilesCallback) { dropzoneConfig.onAddedFilesCallback(files); }
                });
            },
            async accept(imageFile, done) {
                cachedToken = await getAccessToken();
                if (!cachedToken || !isValidBearerToken(cachedToken)) {
                    done('Your session expired. Please sign in again.');
                    return;
                }
                done();
                if(dropzoneConfig.onAcceptCallback) { dropzoneConfig.onAcceptCallback(imageFile); }
            },
            sending(file, xhr, formData) {
                if (cachedToken && isValidBearerToken(cachedToken)) {
                    xhr.setRequestHeader('Authorization', `Bearer ${cachedToken}`);
                }
                formData.append('path', dropzoneConfig.path);
                if(dropzoneConfig.onSendingCallback) { dropzoneConfig.onSendingCallback(formData); }
            },
            success(imageFile, response) {
                clearSlowUploadWarning()
                imageFile.previewElement.classList.add("dz-success");
                if(dropzoneConfig.onSuccessCallback) { dropzoneConfig.onSuccessCallback(response); }
            },
            successmultiple(files, response) {
                if(dropzoneConfig.onSuccessMultipleCallback) { dropzoneConfig.onSuccessMultipleCallback(response); }
            },
            queuecomplete() {
                if(dropzoneConfig.onQueueCompleteCallback) { dropzoneConfig.onQueueCompleteCallback(); }
            }
        });
    }
}
